import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["id", "disabled", "required", "multiple"];
const _hoisted_2 = ["value", "disabled"];
import trans from "../../services/Translator";
import { fromTriState, toTriState } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlBoolSelect',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlBoolSelect');
        const choices = [
            { value: '', label: trans('') },
            { value: 'true', label: trans('boolean.true') },
            { value: 'false', label: trans('boolean.false') },
        ];
        const model = useFieldModel(() => toTriState(props.data));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                    onChange: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(fromTriState)(_unref(model))))),
                    onFocus: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                    onBlur: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                    id: __props.fieldId,
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    multiple: _unref(fieldOptions).multiple ?? undefined,
                    class: "form__control"
                }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(choices, (choice) => {
                        return _createElementVNode("option", {
                            value: choice.value,
                            key: choice.value,
                            disabled: choice.disabled
                        }, _toDisplayString(choice.label), 9, _hoisted_2);
                    }), 64))
                ], 40, _hoisted_1), [
                    [_vModelSelect, _unref(model)]
                ])
            ]));
        };
    }
});
